<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TpSvgIcon',
})
</script>
<template>
    <svg :class="svgClass" v-bind="$attrs" :style="{ color: color, ...iconSize }">
        <use :xlink:href="iconName" />
    </svg>
</template>

<script lang="ts" setup name="TpSvgIcon">
import { computed } from 'vue';

const props = defineProps({
    /**
     * svg名称
     */
    name: {
        type: String,
        required: true
    },
    /**
     * 尺寸
     */
    size: {
        type: Number,
        default: 32
    },
    width: {
        type: Number
    },
    height: {
        type: Number
    },
    /**
     * 颜色
     */
    color: {
        type: String,
        default: ''
    }
});

const iconName = computed(() => `#icon-${props.name}`);
const svgClass = computed(() => {
    if (props.name) {
        return `icon-${props.name}`;
    }
    return 'svg-icon';
});
const iconSize = computed(() => {
    return {
        width: props.width ? `${props.width}px` : `${props.size}px`,
        height: props.height ? `${props.height}px` : `${props.size}px`
    };
});
</script>
